export const UPDATE_PARAMGROUP = 'UPDATE_PARAMGROUP';
export const UPDATE_PARAMGROUP_SUCCESSFUL = 'UPDATE_PARAMGROUP_SUCCESSFUL';
export const UPDATE_PARAMGROUP_FAILED = 'UPDATE_PARAMGROUP_FAILED';



